import { rbac } from "config/rbac";
import { useCheckPerms } from "./useCheckPerms";

export const useIsBrochureAdmin = () => useCheckPerms(rbac.manageBrochures);

export const useIsBrochureUser = () => useCheckPerms(rbac.readBrochures);
